import React from 'react';
import Header from '../../../Reusable/Header';
import Footer from '../../../Reusable/Footer';
import CampaignGrid from './Page components/Campaigns/Campaigns';
import useSEO from '../../../../hooks/useSEO';

const CAMPAIGNS_STRUCTURED_DATA = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'Fundraising Campaigns | Yamba Africa',
  description:
    'Browse active fundraising campaigns across Africa. Donate to causes in education, health, emergencies, and community development.',
  url: 'https://yambaafrica.com/campaigns',
  publisher: {
    '@type': 'Organization',
    name: 'Yamba Africa',
    url: 'https://yambaafrica.com',
  },
};

const Campaigns = () => {
  useSEO({
    title: 'Browse Fundraising Campaigns in Africa',
    description:
      'Explore and donate to active fundraising campaigns across Africa. Support causes in education, healthcare, emergencies, and community development on Yamba Africa.',
    url: 'https://yambaafrica.com/campaigns',
    keywords:
      'fundraising campaigns Africa, donate Uganda, charity campaigns, African causes, crowdfunding campaigns',
    structuredData: CAMPAIGNS_STRUCTURED_DATA,
  });

  return (
    <div>
      <Header />
      <CampaignGrid />
      <Footer />
    </div>
  );
};

export default Campaigns;